module.exports = __webpack_public_path__ + "img/list.icon.e853293e.svg";